@if (show) {
    <div
        role="presentation"
        @backdropAnimation
        (click)="closeModal()"
        class="fixed inset-0 w-full h-full backdrop-blur backdrop-brightness-75 z-30"
    ></div>
}
<div
    role="presentation"
    @contentAnimation
    (click)="closeModal()"
    class="relative mb-6 sm:w-full z-50 duration-150 ease-in-out"
>
    <!--
        mx-4 gives the modal room to breathe on a phone. Every size class is
        sm:-prefixed, so below that breakpoint there was no width and no margin at
        all and the dialog ran edge to edge against the screen.
    -->
    <div
        role="presentation"
        (click)="$event.stopPropagation()"
        [ngClass]="[getMaxWidthClass()]"
        class="mx-4 sm:mx-auto bg-white rounded-lg transition-all shadow-xl"
    >
        <ng-content />
    </div>
</div>
